module.exports = __webpack_public_path__ + "img/step3.70cc3ea9.png";